import styled from 'styled-components'

const Container = styled.div``

const CreationSourceEditorWatermarkPanel = () => {
    return <Container>Watermark</Container>
}

export default CreationSourceEditorWatermarkPanel
